module.exports = __webpack_public_path__ + "static/media/opioidsActive.ed1b6528.svg";